<template>
  <div class="w-full h-full text-center flex flex-col" :class="{ 'safe-area': error }">
    <template v-if="error">
      <h3 class="text-xl font-semibold my-6">{{ $t('result.oops') }}</h3>
      <p class="text-base my-4">{{ $t('result.unexpected_error') }}</p>
      <p class="text-sm">({{ message }})</p>
      <img
        class="my-10 mx-auto w-3/4 max-w-screen-sm"
        src="../../assets/common/warning.svg"
        :alt="message"
      />
      <c-button class="mx-auto mt-auto mb-8" @click="$emit('close')">
        <span>{{ $t('result.close') }}</span>
      </c-button>
    </template>
    <template v-else>
      <error foot />
      <h3 class="my-6 text-xl font-semibold mx-auto text-center w-2/3">
        {{ $t('result.click_scan_again') }}
      </h3>
      <div class="w-full flex mt-auto mb-5 justify-around">
        <c-button width="40%" secondary class="my-3" @click="$emit('close')">
          <span>{{ $t('result.leave') }}</span>
        </c-button>
        <c-button width="40%" class="my-3" @click="$emit('retry')">
          <span>{{ $t('result.scan_again') }}</span>
        </c-button>
      </div>
    </template>
  </div>
</template>

<script>
import Error from '@/components/ShowResult/Error.vue';
import CButton from '@/components/common/CButton.vue';

export default {
  name: 'ScanError',
  components: {
    Error,
    CButton,
  },
  props: {
    error: Boolean,
    message: String,
  },
};
</script>

<style scoped></style>
